import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Car, Loader2 } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import { vehiclesAPI } from '../services/api';
import { usePageMeta } from '../services/seo';
import { useT } from '../services/i18n';

export default function VehicleBrandsPage() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState('');
  const { t } = useT();
  usePageMeta({ title: t('vb.title'), description: t('vb.meta'), path: '/vehicules' });
  useEffect(() => { vehiclesAPI.getBrandPages().then(setData).catch(() => setData({ brands: [] })); }, []);
  const brands = (data?.brands || []).filter((b) => b.name.toLowerCase().includes(q.toLowerCase()));
  const popular = brands.filter((b) => b.popular);

  const Card = ({ b, big }) => (
    <Link to={`/vehicules/${b.slug}`} data-testid={`vehicle-brand-card-${b.slug}`} className={`group bg-white rounded-lg border border-gray-200 hover:border-orange-400 hover:shadow-md transition-all flex ${big ? 'flex-col items-center p-5 gap-3' : 'items-center gap-3 p-3'}`}>
      <span className={`${big ? 'w-20 h-20' : 'w-10 h-10'} flex items-center justify-center shrink-0`}>{b.logo ? <img src={b.logo} alt={b.name} loading="lazy" className="max-w-full max-h-full object-contain" /> : <Car className="text-gray-300" />}</span>
      <span className="min-w-0"><span className={`block font-semibold text-gray-900 truncate ${big ? 'text-center' : 'text-sm'}`}>{b.name}</span><span className={`block text-xs text-gray-500 ${big ? 'text-center' : ''}`}>{t('vb.models', { n: b.models_count, count: b.models_count })}</span></span>
    </Link>
  );

  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      <main className="max-w-7xl mx-auto px-4 py-8 pb-16">
        <Breadcrumb testId="vehicle-brands-breadcrumb" items={[{ label: t('vb.crumb') }]} />
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <h1 className="text-2xl font-bold text-gray-900" data-testid="vehicle-brands-title">{t('vb.title')}</h1>
          <p className="text-gray-700 mt-2">{t('vb.intro')}</p>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('vb.searchPh')} className="mt-4 w-full max-w-md border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-orange-500" data-testid="vehicle-brands-search" />
        </div>
        {!data ? <Loader2 className="animate-spin text-orange-500 mx-auto" /> : (
          <>
            {popular.length > 0 && !q && (
              <section className="mb-8" data-testid="vehicle-brands-popular">
                <h2 className="text-base md:text-lg font-bold text-gray-900 mb-3">{t('vb.popular')}</h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">{popular.map((b) => <Card key={b.slug} b={b} big />)}</div>
              </section>
            )}
            <section data-testid="vehicle-brands-all">
              <h2 className="text-base md:text-lg font-bold text-gray-900 mb-3">{t('vb.all', { n: brands.length })}</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">{brands.map((b) => <Card key={b.slug} b={b} />)}</div>
            </section>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
